import {Card,Row} from 'react-bootstrap';
import LocationItem from './LocationItem';
function Locations(props) {
    return (  <Card>
      <Card.Header as="h5">Where do you want to meet us?</Card.Header>
      <Card.Body>
      <Row className="mb-4">
      {props.centers.map((center) => ( 
      <LocationItem name= {center.Name}
                    key={center.Id}
                    centerId = {center.Id}
                    phone={center.Main_Phone__c}
                    street={center.Street__c}
                    city={center.City__c}
                    state={center.State__c}
                    zip={center.Postal_Code__c}
                    timezone={center.Time_zone__c}
                    setTimezone = {props.setTimezone}
                    setSelectedCenter= {props.setSelectedCenter}
                    setFormValidated = {props.setFormValidated}></LocationItem>
    ))}
    </Row>
      </Card.Body>
    </Card>); 
  }
  export default Locations;